import { createContext, useContext } from 'react'

export interface ExternalMediaState {
  allowed: boolean
  allow: () => void
  revoke: () => void
}

export const ExternalMediaContext = createContext<ExternalMediaState | null>(null)

export function useExternalMedia() {
  const value = useContext(ExternalMediaContext)
  if (!value) throw new Error('useExternalMedia must be used inside ExternalMediaProvider')
  return value
}
